module.exports = fox._r("fonts/mc_icons-webfont.svg", __webpack_public_path__ + "_/_/_/root/fonts/mc_icons-webfont.svg");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/fonts/mc_icons-webfont.svg
// module id = 193
// module chunks = 4